import m from 'mithril';
import { t, } from 'providers/i18nProvider/i18nProvider';
import RegularAdView from './RegularAdView';
import { CLASS_NAMES, } from 'config/adsConfig';


export default class InjectedAdView extends RegularAdView {

  view(ctrl){
    return [
      m(`h5.${ CLASS_NAMES.BLOCK }__title`, t('post_page.ad')),
      super.view(ctrl),
    ];
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/ads/InjectedAdView.js